export default "__VITE_ASSET__DedselIe__"